import { BaseModel } from "@/models/base.model"
import { type IAvailabilityBucket } from "@/interfaces/api/availability-bucket.interface.ts"
import { RecurringAvailability } from "@/models/recurring-availability.model.ts"
import { AvailabilityBlock } from "@/models/availability-block.model.ts"
import { ModelFactory } from "@/factories/model-factory.ts"
import { AvailabilityTypes } from "@/enums/models/availability-types.ts"

export class AvailabilityBucket extends BaseModel implements IAvailabilityBucket {
  public static className = "AvailabilityBucket" // Used for socket communication.
  public static verboseName = "beschikbaarheidsbucket"

  recurringAvailabilities: RecurringAvailability[]
  availabilityBlocks: AvailabilityBlock[]

  constructor(availabilityBucket: IAvailabilityBucket, managed = false) {
    super(availabilityBucket)

    this.recurringAvailabilities = ModelFactory.childModels(
      RecurringAvailability,
      availabilityBucket.recurringAvailabilities,
      managed
    )
    this.availabilityBlocks = ModelFactory.childModels(
      AvailabilityBlock,
      availabilityBucket.availabilityBlocks,
      managed
    )
  }

  public getBaseAvailabilityBlock(): AvailabilityBlock {
    // There will always be one contracted availability block for a KnownBusinessEntityContact. The
    // backend does this automatically on AvailabilityBucket creation.
    return this.availabilityBlocks.find(
      (block) => block.availabilityType === AvailabilityTypes.AVAILABLE
    )!
  }

  public getUnavailabilityBlocks(): AvailabilityBlock[] {
    return this.availabilityBlocks.filter(
      (block) => block.availabilityType === AvailabilityTypes.UNAVAILABLE
    )
  }
}
